export default "__VITE_ASSET__BpZdMnis__"